// extracted by mini-css-extract-plugin
export var checkbox = "TagsGroup-module--checkbox--9ff9a";
export var fadeInAnimation = "TagsGroup-module--fadeInAnimation--35cba";
export var formSelect = "TagsGroup-module--formSelect--60049";
export var input = "TagsGroup-module--input--a2615";
export var monthsWrapper = "TagsGroup-module--monthsWrapper--99067";
export var tooltipContent = "TagsGroup-module--tooltipContent--73f77";
export var tooltipWrapper = "TagsGroup-module--tooltipWrapper--b7ea2";